import { forwardRef } from 'react';
import { StyledCode } from './styled';

const Code = forwardRef((props, ref) => <StyledCode ref={ref} {...props} />);

export default Code;
